export function  isValidCurrency (value) {
  // Matches numbers like "1", "1.23", ".9", ".50"
  return /^(?:\d+|\d*\.\d{1,2})$/.test(value);
};